/**
 * Single source of truth mapping the 6 workflow steps to STABLE named
 * URL slugs (operator pick 2026-08: named paths, flat scheme). A URL
 * like `/workflow/review` stays correct even if steps are added,
 * removed or reordered — unlike a positional `/step/4`.
 *
 * Slug order mirrors workflowState.STEPS so step N ⇄ STEPS[N-1].
 */
import { STEPS } from "./workflowState";

export const WORKFLOW_BASE = "/workflow";

/** 1-indexed step number → slug (defaults to the first step). */
export const stepSlug = (n) => STEPS[(Number(n) || 0) - 1] || STEPS[0];

/** slug → 1-indexed step number, or null when the slug is unknown. */
export const slugStep = (slug) => {
  const i = STEPS.indexOf(slug);
  return i === -1 ? null : i + 1;
};

/** 1-indexed step number → full path (e.g. 4 → "/workflow/review"). */
export const stepPath = (n) => `${WORKFLOW_BASE}/${stepSlug(n)}`;

/** Parse the active step number out of a pathname, or null if not on a
 *  workflow route. */
export const parseStepFromPath = (pathname) => {
  const m = (pathname || "").match(/\/workflow\/([a-z0-9-]+)/i);
  return m ? slugStep(m[1]) : null;
};
